import React from 'react';
import './../styles/dashboard.css';
import { parseDate } from '../utils/Miscellaneous';

const OrderTrackingDataGrid = ({ data }) => {
    const statusClass = data.Status === 'Error' ? 'status-error' : 'status-success';

    return (
        <div className="grid-container">
            <div className="grid-item"><strong>APP System:</strong> {data.APP_system}</div>
            <div className="grid-item"><strong>Order Number:</strong> {data.orderNumber}</div>
            <div className="grid-item"><strong>Order Source Type:</strong> {data.orderSourceType}</div>
            <div className={`grid-item ${statusClass}`}><strong>Customer Name:</strong> {data.customerName}</div>
            <div className="grid-item"><strong>Order Status Details:</strong></div>

            <div className="order-details-wrapper">
                { data.orderStatusDetails && data.orderStatusDetails.map((detail, index) => (
                    <React.Fragment key={index}>
                        <div className="grid-item"><strong>Order Status Code:</strong> {detail.orderStatusCode || 'N/A'}</div>
                        <div className="grid-item"><strong>Order Status Description:</strong> {detail.orderStatusDescription}</div>
                        <div className="grid-item"><strong>Order Status Timestamp:</strong> {parseDate(detail.orderStatusTimestamp).toLocaleString()}</div>
                        <div className="grid-item"><strong>Reference Order Number:</strong> {data.orderNumber}</div>
                        <div className="grid-item"><strong>Status Receive Timestamp:</strong> {parseDate(detail.statusReceiveTimestamp).toLocaleString()}</div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};



export default OrderTrackingDataGrid;

/*
{
	"APP_system": "SOFTEON",
	"orderNumber": "S319950",
	"orderSourceType": "SO",
	"customerName": "NAVICO",
	"orderStatusDetails": [
		{
			"orderStatusCode": "70",
			"orderStatusDescription": "Pick Completed",
			"orderStatusTimestamp": "20241112 145128.000",
			"referenceOrderNumber": "5496",
			"statusReceiveTimestamp": "20241119 015352.000"
		}
	]
}
    */